import React from "react";

//import material-UI
import {makeStyles, createStyles, Theme} from "@material-ui/core";
import {Box, Button} from "@material-ui/core";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import {useDispatch} from "react-redux";

//import component
import SearchForm from "./SearchForm";
import {useNavigate} from "react-router-dom";
import SwitchControl from "./SwitchControl";
import SelectBox from "./SelectBox";
import DonutLargeIcon from "@material-ui/icons/DonutLarge";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "20px 36px",
      width: "100%",
      fontSize: "26px",
      fontWeight: "bold",
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.custom.main,

      "& h2": {
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "0",
          left: "-10px",
          width: "6px",
          height: "100%",
          backgroundColor: "red",
          borderRadius: "5px",
        },
      },
    },
    nonSubTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      fontSize: "26px",
      fontWeight: "bold",
      color: theme.palette.primary.dark,
      backgroundColor: theme.palette.background.default,
    },
    addBtn: {
      color: theme.palette.primary.main,
    },
  })
);

type ListFilterProps = {
  setSearchWord?: (value: string) => void;
  searchDispatcher?: (page?: number, inputWord?: string) => void;
  page?: number;
  searchWord?: string;
  subTitle?: string;
  buttonTitle?: string;
  endPoint?: string;
  modal?: () => void;
  changeHandler?: any;
};

const ListFilter = ({
  setSearchWord,
  searchDispatcher,
  page,
  searchWord,
  subTitle,
  buttonTitle,
  endPoint,
  modal,
  changeHandler: Handler,
}: ListFilterProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <>
      <Box className={subTitle ? classes.subTitle : classes.nonSubTitle}>
        {subTitle ? <h2>{subTitle}</h2> : <DonutLargeIcon style={{width: "48px"}} />}
        <SwitchControl />
        {setSearchWord && searchDispatcher && (
          <SearchForm
            setSearchWord={setSearchWord}
            searchDispatcher={searchDispatcher}
            page={page}
            searchWord={searchWord}
          />
        )}
        <SelectBox
          filterChangeHandler={() => {
            if (Handler !== undefined) Handler();
          }}
        />
        {buttonTitle && (
          <Button
            className={classes.addBtn}
            variant="outlined"
            size="large"
            onClick={() => {
              modal && dispatch(modal());
              navigate(endPoint!);
            }}
            endIcon={<AddToPhotosIcon>send</AddToPhotosIcon>}
          >
            {buttonTitle}
          </Button>
        )}
      </Box>
    </>
  );
};

export default ListFilter;
